import Helper from './Helper';

class Overlay {
  constructor(config = {}) {
    const {
      overlaySelector,
      overlayCloseSelector
    } = config;

    this.overlaySelector = document.querySelector(overlaySelector);
    this.overlayCloseSelector = document.querySelectorAll(overlayCloseSelector);

    if(this.overlaySelector){
      this.bindEvents();
    }
  }

  bindEvents(){
  //  this.fadeIn(this.overlaySelector);

    this.overlayCloseSelector.forEach(close => {
      close.addEventListener('click', e => {
        e.preventDefault();
        this.fadeOut(this.overlaySelector);
      });
    });
  }

  fadeIn(element){
    // console.log("fadeIn", element.style.opacity);
    // element.style.display = "flex";
    // element.style.opacity += 0.1;
    // if(element.style.opacity > 1.0) {
    //     element.style.opacity = 1.0;
    // } else {
    //     setTimeout(e => {
    //       this.fadeIn(element)
    //     }, 100);
    // }
  }

  fadeOut(element){
    element.style.display = "none";
  }

} export default Overlay;
